import { Popover, Transition } from "@headlessui/react";
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";
import { GoTriangleDown } from "@react-icons/all-files/go/GoTriangleDown";
import { HiChevronRight } from "@react-icons/all-files/hi/HiChevronRight";
import { RiFolder3Fill } from "@react-icons/all-files/ri/RiFolder3Fill";
import { SiMarkdown } from "@react-icons/all-files/si/SiMarkdown";
import { VscCollapseAll } from "@react-icons/all-files/vsc/VscCollapseAll";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { CopyBlock, nord } from "react-code-blocks";
import skillData from "../data/SkillData.json";
import { IoLogoJavascript } from "@react-icons/all-files/io5/IoLogoJavascript";
import { GiWolfHowl  } from "@react-icons/all-files/gi/GiWolfHowl";


export default function AboutMe() {
  const [render, setRender] = useState("my-bio");

  function Render(value) {
    if (value === "/") {
      return <Root />;
    } else if (value === "my-bio") {
      return <MyBio closeBio={setRender} />;
    } else if (value === "gear") {
      return <Gear closeGear={setRender} />;
    } else if (value === "work") {
      return <Work closeGear={setRender} />;
    }
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -50, opacity: 0 }}
    >
      <div className="lg:grid grid-cols-12 h-full flex flex-col ">
        <div className="col-span-2 grid lg:grid-cols-6">
          <div className="col-span-6 lg:border-r lg:border-b-0 border-b border-[#1E2D3D] text-white gap-2.5 relative overflow-hidden">
            <PersonalInfo setRender={setRender} render={render} />
          </div>
        </div>
        <AnimatePresence initial={false}>{Render(render)}</AnimatePresence>
      </div>
    </motion.div>
  );
}

function Root() {
  return (
    <motion.div
      className="w-full h-full flex items-center justify-center text-white col-span-10"
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 50, opacity: 0 }}
    >
      Aquí no hay nada, haz clic en algo
    </motion.div>
  );
}

function MyBio({ closeBio }) {
  return (
    <motion.div
      className="col-span-10 h-full flex  justify-center overflow-hidden flex-col"
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 50, opacity: 0 }}
    >
      <div className="w-full">
        <div className="grid grid-cols-12 border-b border-[#1E2D3D]">
          <div className="lg:col-span-2 md:col-span-6 col-span-12  text-white border-r border-[#1E2D3D] py-2.5 relative px-4">
            <button
              className="absolute top-1/2 -translate-y-1/2 right-4"
              onClick={() => {
                closeBio("/");
              }}
            >
              <AiOutlineClose />
            </button>
            <p className="pr-5 truncate">personal.js</p>
          </div>
        </div>
      </div>
      <div className="overflow-y-auto scrollbar-thin h-full text-wrap">
        <CopyBlock
          language={`jsx`}
          text={`// Mi perfil
const nombre = 'Camilo Rivera'
let profesión = 'Desarrollador Full Stack Web Junior'
let ubicación = 'En algún lugar de la web'
let teléfono = +57 319 212 1761
let email = 'camilorivera@camilorivera.co'

// Mi Experiencia
let info = 'Experto en soluciones Code, Low Code y No Code. Desde la línea de código más precisa hasta la automatización más ingeniosa.'

// Mis Hobbies
let hobbies = [
  "Videojuegos 🎮"
  "Programación 👩‍💻", 
  "Música 🎵", 
  "Futbol ⚽", 
  "Más programación 😎"
]
          `}
          showLineNumbers={true}
          theme={nord}
          codeBlock
        />
      </div>
    </motion.div>
  );
}

function Work({ closeWork }) {
  return (
    <motion.div
      className="col-span-10 h-full flex  justify-center overflow-hidden flex-col"
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 50, opacity: 0 }}
    >
      <div className="w-full">
        <div className="grid grid-cols-12 border-b border-[#1E2D3D]">
          <div className="lg:col-span-2 md:col-span-6 col-span-12 text-white border-r border-[#1E2D3D] py-2.5 relative px-4">
            <button
              className="absolute top-1/2 -translate-y-1/2 right-4"
              onClick={() => {
                closeWork("/");
              }}
            >
              <AiOutlineClose />
            </button>
            <p className="pr-5 truncate">trabajo.js</p>
          </div>
        </div>
      </div>
      <div className="overflow-y-auto scrollbar-thin h-full text-wrap">
        <CopyBlock
          language={`jsx`}
          text={`// Último cargo (Actualmente)
let profesion = 'Full Stack Web Developer Junior',
let empresa = 'MIMUSA SL',

// Habilidades importantes
let lenguajes = [
  "PHP",
  "Phyton",
  "JavaScript",
]

let frameworks = [
  "Bootstrap",
  "Tailwind",
  "SASS",
  "React JS",
  "Laravel",
  "Django",
]
  
let cms = [
  "WordPress",
  "Shopify"
]`}
          showLineNumbers={true}
          theme={nord}
          codeBlock
        />
      </div>
    </motion.div>
  );
}

function Gear({ closeGear }) {
  function Content({ title, list }) {
    return (
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-[#c8cfd6] mb-6 border-b border-white/10 pb-2 hover:text-violet-400 transition">
          {title}
        </h2>
        <div className="grid xl:grid-cols-2 lg:grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-1">
          {list.map((data, index) => (
            <div key={index} className="bg-white/5 p-4 rounded-xl shadow-sm hover:shadow-lg transition-all border border-white/10">
              <div className="flex items-center text-[#7dd3fc] text-lg font-semibold mb-1 gap-2 hover:text-violet-400 ">
                <GiWolfHowl color="#fff"/>
                {data.item}
              </div>
              <p className="text-sm text-white/70 mb-2">{data.desc}</p>
              <div className="flex flex-wrap gap-2">
                {data.type?.map((typeItem, i) => (
                  <span
                    key={i}
                    className="text-xs bg-[#1e2d3d] text-[#fff] py-1 px-3 rounded-full border border-white/10 capitalize"
                  >
                    {typeItem}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <motion.div
      className="col-span-10 h-full flex justify-center overflow-hidden flex-col text-white"
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 50, opacity: 0 }}
    >
      {/* Encabezado tipo archivo */}
      <div className="w-full">
        <div className="grid grid-cols-12 border-b border-[#1E2D3D] ">
          <div className="lg:col-span-3 md:col-span-6 col-span-12 border-r border-[#1E2D3D] py-3 px-4 flex items-center justify-between">
            <p className="text-sm text-sky-300">habilidades.md</p>
            <button onClick={() => closeGear("/")} className="text-white hover:text-red-400 transition">
              <AiOutlineClose size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* Contenido scrollable con animación */}
      <div className="overflow-y-auto scrollbar-thin h-full lg:p-16 md:p-8 p-4 grid grid-cols-1 sm:grid-cols-2 gap-10">
        {skillData.skillType.map((data, index) => (
          <Content title={data.campo} key={index} list={data.skillList} />
        ))}
      </div>
    </motion.div>
  );
}

function PersonalInfo({ setRender, render }) {
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenBio, setIsOpenBio] = useState(true);

  function openPopover() {
    setIsOpen(!isOpen);
  }

  function CollapseAll() {
    setIsOpenBio(false);
  }

  function openPopoverBio() {
    setIsOpenBio(!isOpenBio);
  }

  return (
    <Popover>
      <>
        <div className="relative">
          <Popover.Button
            className={`
                ${isOpen ? "text-white" : "text-white/50"}
               flex items-center gap-2.5 border-b border-[#1E2D3D] py-2.5 px-4 w-full`}
            onClick={openPopover}
          >
            <GoTriangleDown
              className={`${isOpen ? "" : "-rotate-90"} transition-all`}
            />
            <span className="text-left pr-5 truncate">info-personal</span>
          </Popover.Button>
          <button
            onClick={CollapseAll}
            className="absolute top-1/2 -translate-y-1/2 right-2"
          >
            <VscCollapseAll />
          </button>
        </div>

        <Transition
          show={isOpen}
          enter="transition ease-in duration-200"
          enterFrom="opacity-0 -translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-out duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-1"
        >
          <Popover.Panel className=" px-4 text-white py-4">
            <Popover.Group className={`flex flex-col gap-1.5`}>
              <Popover>
                <>
                  <Popover.Button
                    className={`
                ${isOpenBio ? "text-white" : "text-white/50"}
               flex items-center gap-2.5  w-full transition-colors`}
                    onClick={openPopoverBio}
                  >
                    <HiChevronRight
                      className={`${isOpenBio ? "rotate-90" : ""
                        } transition-all`}
                    />
                    <RiFolder3Fill
                      className={`${isOpenBio ? "text-[#E99287]" : "text-[#b36d64]"
                        } transition-colors`}
                    />
                    <span className="pr-5 truncate">mi-perfil</span>
                  </Popover.Button>

                  <Transition
                    show={isOpenBio}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 -translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-linear duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-1"
                    className="flex flex-col"
                  >
                    <Popover.Panel
                      className={`px-4 my-1 ml-2.5 inline-flex items-center gap-2.5 transition-colors ${render === "my-bio" ? "text-white" : "text-[#607B96]"
                        }`}
                      as="button"
                      onClick={() => setRender("my-bio")}
                    >
                      <IoLogoJavascript />
                      <span className="truncate">personal.js</span>
                    </Popover.Panel>
                    <Popover.Panel
                      className={`px-4 my-1 ml-2.5 inline-flex items-center gap-2.5 transition-colors ${render === "work" ? "text-white" : "text-[#607B96]"
                        }`}
                      as="button"
                      onClick={() => setRender("work")}
                    >
                      <IoLogoJavascript />
                      <span className="truncate">trabajo.js</span>
                    </Popover.Panel>
                    <Popover.Panel
                      className={`px-4 my-1 ml-2.5 inline-flex items-center gap-2.5 transition-colors ${render === "gear" ? "text-white" : "text-[#607B96]"
                        }`}
                      as="button"
                      onClick={() => setRender("gear")}
                    >
                      <SiMarkdown />
                      <span className="truncate">habilidades.md</span>
                    </Popover.Panel>
                  </Transition>
                </>
              </Popover>
            </Popover.Group>
          </Popover.Panel>
        </Transition>
      </>
    </Popover>
  );
}
